export default "__VITE_ASSET__i0X9GVIl__"